import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { InfoGroupModel } from "@/modules/InfoGroup/models/InfoGroup";
import {
  DRAG_OPTIONS,
  GENERATE_PDF_CONSTANTS,
  METHODS
} from "../../constants/generate-pdf.contants";
import { FieldGroup } from "@/modules/InfoGroup/models/FieldGroup";
import { FieldUser } from "@/modules/User/models/FieldUser";
import { UserService } from "@/modules/User/services/UserService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { UserInformationModel } from "@/modules/User/models/UserInformationModel";
import { FullSchema } from "@/shared/models/FullSchema";
import { Schema } from "@/modules/FormTemplate/models/Schema";
import Dropdown from "../Dropdown/Dropdown.vue";
import { Http } from "@status/codes";
import draggable from "vuedraggable";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";

Vue.use(Vuetify);
@Component({
  name: "SelectDnD",
  components: { Dropdown, draggable }
})
export default class SelectDnD extends Vue {
  @Inject() private userService!: UserService;

  @Prop({ default: "" }) public TITLE!: string;
  @Prop({ default: "" }) public LABEL!: string;
  @Prop({ default: false }) public error!: boolean;
  @Prop({ default: [] }) userId!: string;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  listInfoGroup: InfoGroupModel[] = [];
  groupsChoosen: InfoGroupModel[] = [];
  groupsFields: {
    [key: string]: { data?: FieldGroup[]; error: boolean };
  } = {};
  isDragging = false;
  fieldsSelected: FieldUser[] = [];
  infoGroupList: FullSchema[] = [];
  choosenInfoGroupList: FullSchema[] = [];
  userInfo!: UserInformationModel;

  HELPER_TEXT = GENERATE_PDF_CONSTANTS.TITLES.HELPER_TEXT;
  HELPER_TEXT_DND = GENERATE_PDF_CONSTANTS.TITLES.HELPER_TEXT_DND;

  async mounted() {
    try {
      const response = await this.userService.getUserById(this.userId);
      if (response.code !== Http.Found) {
        return Snackbar.popError(
          GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_USER_INFO
        );
      }
      this.userInfo = response.data as UserInformationModel;

      this.fieldsSelected = this.userInfo?.userData.schema?.schema.allOf[0].required?.map(
        item => ({
          title: this.userInfo?.userData.schema?.schema.allOf[0].properties[
            item
          ].title,
          value: this.userInfo.userData.fields[item]
        })
      ) as FieldUser[];
      this.$emit(METHODS.EMIT_FIELDS_SELECTED, this.fieldsSelected);

      this.infoGroupList = this.userInfo?.userData.schema?.schema.allOf || [];
      this.choosenInfoGroupList = this.infoGroupList[0]
        ? [this.infoGroupList[0]]
        : [];
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_USER_INFO;

      Snackbar.popError(errorMessage);
    }
  }

  choosenField(property: [string, Schema]) {
    if (
      this.fieldsSelected.find(
        fieldSelected => fieldSelected.title === property[1].title
      )
    ) {
      this.fieldsSelected = this.fieldsSelected.filter(
        fieldSelected => fieldSelected.title !== property[1].title
      );
    } else {
      if (this.userInfo.userData.fields[property[0]]) {
        this.fieldsSelected.push({
          title: property[1].title,
          value: this.userInfo.userData.fields[property[0]] as string
        });
      } else {
        const phoneComponent = this.userInfo.userData.schema?.phoneComponentList.find(
          phoneComponent => phoneComponent.title === property[1].title
        );
        if (phoneComponent) {
          this.fieldsSelected.push({
            title: phoneComponent.title,
            value: phoneComponent.formattedNumber as string
          });
        } else {
          Snackbar.popError(GENERATE_PDF_CONSTANTS.MESSAGES.FIELD_NOT_FOUND);
        }
      }
    }
    this.$emit(METHODS.EMIT_FIELDS_SELECTED, this.fieldsSelected);
  }

  dragOptions() {
    return DRAG_OPTIONS;
  }

  onMove({ relatedContext, draggedContext }: any) {
    const relatedElement = relatedContext.element;
    const draggedElement = draggedContext.element;
    return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
  }

  updateDraggable() {
    this.$emit(METHODS.EMIT_FIELDS_SELECTED, this.fieldsSelected);
  }
}
